import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { StyledDirectionIconWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const StyledScoreValue = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin-right: 5px;
    min-width: 16px;
    height: 16px;
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
    font-weight: 500;
    background: ${colorsPalettes.bluegrey[200]};
    padding: 4px;
`;

export const StyledScoreValueWrapper = styled(StyledScoreValue)`
    margin-right: 9px;
`;

export const StyledIntentTopicWithEventInfoTitle = styled.div`
    display: flex;
    margin-right: 4px;
    align-items: center;
    ${mixins.setFontVariant("primaryItem", colorsPalettes.carbon[500])};
    font-size: 10px;
`;

export const StyledIntentTopicWithEventInfoWrapper = styled(FlexRow)``;

export const StyledDirectionIcon = styled(StyledDirectionIconWrapper)`
    & .SWReactIcons svg {
        vertical-align: baseline;
    }
`;
